const namespace = "workstudy";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "WorkStudy",
  namespace,
  description: null,
  version: "1.0.0",
  icon: "mdi-gauge",
  accentColor: "#000080",
  mainNavEnabled: false,
  topBarEnabled: false,
  parentRoute: "/workstudy",
  defaultRoute: "home",
  childRoutes,
  component : () => import(/* webpackChunkName: "workstudyplus-parent" */ "@/apps/workstudy/Application.vue"),
  settings: {
    
    environment: "",
    apiUrl: "",
    removeHeaders:"",
    clientId : "",
    scope : "",
    authorizeUrl : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    tokenUrl : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    logoutUrl : `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
    redirect_uri: window.location.origin,
    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 },
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
    isAzureDeployed: '1',
    //env_color:'"primary"', //PROD

    appNavigation: [
      // {
      //   text: "Home",
      //   link: "home",
      //   icon: "mdi-home",
      // },
      {
        text: "Home",
        link: "home",
        icon: "mdi-home",
        roles: ["site admin", "global admin", "viewer"],
      },
      {
        icon: "mdi-account-lock-outline",
        text: "Admin",
        link: "/workstudy/admin",
        roles: ["site admin", "global admin"],
        items: [
        {
          text: "Users",
          link: "users",
          icon: "mdi-account-multiple-outline",
          roles: ["site admin", "global admin"],
        },
        {
          text: "AuditLogs",
          link: "auditlogs",
          icon: "mdi-view-list",
          roles: ["site admin", "global admin"],
        },
      ],
    }
    ],
  }, 
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    // themeColor : {
    //   default: "red",
    //   storageMode : localStorage,
    // },
    isTrue : {
      default: true,
      storageMode : sessionStorage,
    },
    userDetails : {
      default: null,
      storageMode : sessionStorage,
    },
    pageTitle: {
      default: "workstudy",
      storageMode: localStorage,
    },
    // userDetails: {
    //   default: null,
    //   storageMode: sessionStorage,
    // },
    impersonationDetails: {
      default: null,
      storageMode: sessionStorage,
    },
    credentialCache: {
      default: {},
      storageMode: sessionStorage,
    },
    userRoles: {
      default: [],
      storageMode: sessionStorage,
    },
    navItems: {
      default: [],
      storageMode: sessionStorage,
    }
  }

}

export default AppConfig.merge(appConfig);


